import { FilterSelectionOption } from '@core/ui';
import { AttributeFacet, FacetFeatureValue, ListFacetBase } from '@mp/shared/facets/domain';

import { BucketIconFn } from '../models';

export function mapBucketToOption<T = unknown>(
  bucket: ListFacetBase.Bucket<T>,
  bucketIconFn?: BucketIconFn<T>,
): FilterSelectionOption<string> {
  return {
    count: bucket.count,
    label: bucket.label,
    value: bucket.value,
    icon: bucketIconFn ? bucketIconFn(bucket) : undefined,
  };
}

export function mapFacetBucketsToOptions<T = unknown>(
  buckets: readonly ListFacetBase.Bucket<T>[],
  bucketIconFn?: BucketIconFn<T>,
): FilterSelectionOption<string>[] {
  return buckets.map((bucket) => mapBucketToOption(bucket, bucketIconFn));
}

// TODO Adjust typing
export function mapAttributeFacetChildrenToOptions<T = unknown>(
  buckets: readonly AttributeFacet.BucketLevel1<T>[],
): FilterSelectionOption<FacetFeatureValue>[] {
  return buckets.map((bucket) => mapBucketToOption(bucket)) as FilterSelectionOption<FacetFeatureValue>[];
}
